import { UserAgent, EventListener } from "silver";
import { getMobileIntentType, AppIntentType } from "core/AppIntents";

type DownloadBookFn = (bookId: number) => void;

export class DownloadBookService {

	public readonly onAvailabilityChange = EventListener.create("availabilityChange");
	private downloadFn: DownloadBookFn|null = null;

	constructor(
		private userAgent: UserAgent,
		private chromeAppId: string
	) {
		this.initDownloadHandler();
	}

	private initDownloadHandler(): void {
		const intent = getMobileIntentType(this.userAgent);

		switch (intent) {
			case AppIntentType.iOS:
				this.downloadFn = DownloadBookService.downloadBookIos;
				break;
			case AppIntentType.Android:
				this.downloadFn = DownloadBookService.downloadBookAndroid;
				break;
			case AppIntentType.ChromeOS:
				(window as any).chrome.runtime.sendMessage(this.chromeAppId, { message: "version" }, (reply: null|{ version: number}) => {
					if (!reply || !reply.version) {
						return;
					}
					this.downloadFn = (bookId: number): void => {
						this.downloadBookChrome(bookId);
					};
					this.onAvailabilityChange.trigger({ });
				});
		}
	}

	get available(): boolean {
		return this.downloadFn !== null;
	}

	public downloadBook(bookId: number): void {
		if (! this.available) {
			throw new Error("Downloading books is not available");
		}
		(this.downloadFn as DownloadBookFn)(bookId);
	}

	private static downloadBookIos(bookId: number): void {
		window.location.href = `myon://books/${bookId}`;
	}

	private static downloadBookAndroid(bookId: number): void {
		window.location.href = `intent:#Intent;action=com.capstonedigital.DOWNLOAD_BOOK;package=com.capstonedigital;i.book_id=${bookId};end`;
	}

	private downloadBookChrome(bookId: number): void {
		(window as any).chrome.runtime.sendMessage(this.chromeAppId, {
			message: "downloadBook",
			id:      bookId
		});
	}
}
